/* eslint-disable no-unused-vars */
import { createUseStyles } from 'react-jss'
import hexToRgba from '../../helpers/hex-to-rgba'

const useStyles = createUseStyles((theme) => ({
  '@keyframes filterItemLoading': {
    from: {
      transform: 'translateX(-100%)',
    },
    to: {
      transform: 'translateX(100%)',
    },
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    // flexWrap: 'wrap',
    gap: 'var(--ui-spacer-m)',
  },
  containerLoading: {
    position: 'relative',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--ui-spacer-s)',
    padding: 'var(--ui-spacer-s) 0',
    '&::after': {
      content: '""',
      display: 'block',
      opacity: 0.5,
      position: 'absolute',
      left: '25%',
      top: 0,
      right: '25%',
      bottom: 0,
      background: `linear-gradient(to right, ${hexToRgba(theme.colors.background, 0)} 0%,${hexToRgba(theme.colors.background, 1)} 50%,${hexToRgba(theme.colors.background, 0)} 100%)`,
      transform: 'translateX(-100%)',
      animationName: '$filterItemLoading',
      animationDuration: '1s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
    },
  },
  loadingBlock: {
    display: 'block',
    backgroundColor: 'var(--ui-color-light)',
    overflow: 'hidden',
    textIndent: '-9999em',
    borderRadius: 'var(--ui-radius-m)',
    height: '2.4rem',
  },
  searchInput: {
    margin: 0,
  },
  subSection: {},
  subSectionTitle: {},
  subSectionTitleText: {
    fontSize: '1.4rem',
    fontWeight: 'normal',
    lineHeight: 1.25,
    margin: 0,
  },
  checkbox: {
    padding: 'var(--ui-spacer-s) 0',
    cursor: 'pointer',
    gap: 'var(--ui-spacer-m)',
    // flexBasis: 'calc(33.3% - (var(--ui-spacer-m) * 2 / 3))',
  },
  radio: {
    alignItems: 'center',
  },
  checkboxLabel: {
    marginLeft: 0,
    color: theme.colors.gray700,
  },
  emptyScreen: {
    padding: 'var(--ui-spacer-l) 0',
  },
}))

export default useStyles
